// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1AuthAccountData, DeleteApiV1AuthAccountErrors, DeleteApiV1AuthAccountResponses, DeleteApiV1BillingTeamsByIdSubscriptionData, DeleteApiV1BillingTeamsByIdSubscriptionErrors, DeleteApiV1BillingTeamsByIdSubscriptionResponses, DeleteApiV1SnippetsByIdData, DeleteApiV1SnippetsByIdErrors, DeleteApiV1SnippetsByIdFragmentsByFragmentIdData, DeleteApiV1SnippetsByIdFragmentsByFragmentIdErrors, DeleteApiV1SnippetsByIdFragmentsByFragmentIdResponses, DeleteApiV1SnippetsByIdInvitationsByInvitationIdData, DeleteApiV1SnippetsByIdInvitationsByInvitationIdErrors, DeleteApiV1SnippetsByIdInvitationsByInvitationIdResponses, DeleteApiV1SnippetsByIdPermanentData, DeleteApiV1SnippetsByIdPermanentErrors, DeleteApiV1SnippetsByIdPermanentResponses, DeleteApiV1SnippetsByIdResponses, DeleteApiV1SnippetsByIdSharesByUserIdData, DeleteApiV1SnippetsByIdSharesByUserIdErrors, DeleteApiV1SnippetsByIdSharesByUserIdResponses, DeleteApiV1SnippetsByIdSharesMeData, DeleteApiV1SnippetsByIdSharesMeErrors, DeleteApiV1SnippetsByIdSharesMeResponses, DeleteApiV1SnippetsByIdTagsByTagIdData, DeleteApiV1SnippetsByIdTagsByTagIdErrors, DeleteApiV1SnippetsByIdTagsByTagIdResponses, DeleteApiV1TagsByIdData, DeleteApiV1TagsByIdErrors, DeleteApiV1TagsByIdResponses, DeleteApiV1TeamsByIdData, DeleteApiV1TeamsByIdErrors, DeleteApiV1TeamsByIdInvitationsByInvitationIdData, DeleteApiV1TeamsByIdInvitationsByInvitationIdErrors, DeleteApiV1TeamsByIdInvitationsByInvitationIdResponses, DeleteApiV1TeamsByIdMembersByUserIdData, DeleteApiV1TeamsByIdMembersByUserIdErrors, DeleteApiV1TeamsByIdMembersByUserIdResponses, DeleteApiV1TeamsByIdResponses, GetApiV1AntiforgeryTokenData, GetApiV1AntiforgeryTokenResponses, GetApiV1AuthMeData, GetApiV1AuthMeResponses, GetApiV1BillingPlanData, GetApiV1BillingPlanResponses, GetApiV1BillingTeamsByIdData, GetApiV1BillingTeamsByIdErrors, GetApiV1BillingTeamsByIdResponses, GetApiV1InvitationsData, GetApiV1InvitationsResponses, GetApiV1SnippetsByIdData, GetApiV1SnippetsByIdErrors, GetApiV1SnippetsByIdInvitationsData, GetApiV1SnippetsByIdInvitationsErrors, GetApiV1SnippetsByIdInvitationsResponses, GetApiV1SnippetsByIdResponses, GetApiV1SnippetsByIdSharesData, GetApiV1SnippetsByIdSharesErrors, GetApiV1SnippetsByIdSharesResponses, GetApiV1SnippetsData, GetApiV1SnippetsErrors, GetApiV1SnippetsResponses, GetApiV1TagsData, GetApiV1TagsResponses, GetApiV1TeamsByIdData, GetApiV1TeamsByIdErrors, GetApiV1TeamsByIdInvitationsData, GetApiV1TeamsByIdInvitationsErrors, GetApiV1TeamsByIdInvitationsResponses, GetApiV1TeamsByIdResponses, GetApiV1TeamsData, GetApiV1TeamsResponses, PostApiV1AuthChangePasswordData, PostApiV1AuthChangePasswordErrors, PostApiV1AuthChangePasswordResponses, PostApiV1AuthConfirmEmailData, PostApiV1AuthConfirmEmailErrors, PostApiV1AuthConfirmEmailResponses, PostApiV1AuthForgotPasswordData, PostApiV1AuthForgotPasswordErrors, PostApiV1AuthForgotPasswordResponses, PostApiV1AuthLoginData, PostApiV1AuthLoginErrors, PostApiV1AuthLoginResponses, PostApiV1AuthLogoutData, PostApiV1AuthLogoutResponses, PostApiV1AuthRegisterData, PostApiV1AuthRegisterErrors, PostApiV1AuthRegisterResponses, PostApiV1AuthResendVerificationData, PostApiV1AuthResendVerificationErrors, PostApiV1AuthResendVerificationResponses, PostApiV1AuthResetPasswordData, PostApiV1AuthResetPasswordErrors, PostApiV1AuthResetPasswordResponses, PostApiV1BillingTeamsByIdCheckoutData, PostApiV1BillingTeamsByIdCheckoutErrors, PostApiV1BillingTeamsByIdCheckoutResponses, PostApiV1BillingTeamsByIdPortalData, PostApiV1BillingTeamsByIdPortalErrors, PostApiV1BillingTeamsByIdPortalResponses, PostApiV1InvitationsByIdAcceptData, PostApiV1InvitationsByIdAcceptErrors, PostApiV1InvitationsByIdAcceptResponses, PostApiV1InvitationsByIdDeclineData, PostApiV1InvitationsByIdDeclineErrors, PostApiV1InvitationsByIdDeclineResponses, PostApiV1SnippetsByIdFragmentsData, PostApiV1SnippetsByIdFragmentsErrors, PostApiV1SnippetsByIdFragmentsResponses, PostApiV1SnippetsByIdInvitationsByInvitationIdResendData, PostApiV1SnippetsByIdInvitationsByInvitationIdResendErrors, PostApiV1SnippetsByIdInvitationsByInvitationIdResendResponses, PostApiV1SnippetsByIdRestoreData, PostApiV1SnippetsByIdRestoreErrors, PostApiV1SnippetsByIdRestoreResponses, PostApiV1SnippetsByIdSharesData, PostApiV1SnippetsByIdSharesErrors, PostApiV1SnippetsByIdSharesResponses, PostApiV1SnippetsByIdTagsData, PostApiV1SnippetsByIdTagsErrors, PostApiV1SnippetsByIdTagsResponses, PostApiV1SnippetsData, PostApiV1SnippetsErrors, PostApiV1SnippetsResponses, PostApiV1TagsData, PostApiV1TagsErrors, PostApiV1TagsResponses, PostApiV1TeamsByIdInvitationsByInvitationIdResendData, PostApiV1TeamsByIdInvitationsByInvitationIdResendErrors, PostApiV1TeamsByIdInvitationsByInvitationIdResendResponses, PostApiV1TeamsByIdInvitationsData, PostApiV1TeamsByIdInvitationsErrors, PostApiV1TeamsByIdInvitationsResponses, PostApiV1TeamsData, PostApiV1TeamsErrors, PostApiV1TeamsResponses, PutApiV1SnippetsByIdArchiveData, PutApiV1SnippetsByIdArchiveErrors, PutApiV1SnippetsByIdArchiveResponses, PutApiV1SnippetsByIdData, PutApiV1SnippetsByIdDocumentData, PutApiV1SnippetsByIdDocumentErrors, PutApiV1SnippetsByIdDocumentResponses, PutApiV1SnippetsByIdErrors, PutApiV1SnippetsByIdFavoriteData, PutApiV1SnippetsByIdFavoriteErrors, PutApiV1SnippetsByIdFavoriteResponses, PutApiV1SnippetsByIdFragmentsByFragmentIdData, PutApiV1SnippetsByIdFragmentsByFragmentIdErrors, PutApiV1SnippetsByIdFragmentsByFragmentIdResponses, PutApiV1SnippetsByIdFragmentsOrderData, PutApiV1SnippetsByIdFragmentsOrderErrors, PutApiV1SnippetsByIdFragmentsOrderResponses, PutApiV1SnippetsByIdResponses, PutApiV1TagsByIdData, PutApiV1TagsByIdErrors, PutApiV1TagsByIdResponses, PutApiV1TeamsByIdData, PutApiV1TeamsByIdErrors, PutApiV1TeamsByIdMembersByUserIdData, PutApiV1TeamsByIdMembersByUserIdErrors, PutApiV1TeamsByIdMembersByUserIdResponses, PutApiV1TeamsByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Issue an antiforgery token for the current session.
 */
export const getApiV1AntiforgeryToken = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1AntiforgeryTokenData, ThrowOnError>): RequestResult<GetApiV1AntiforgeryTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1AntiforgeryTokenResponses, unknown, ThrowOnError>({ url: '/api/v1/antiforgery/token', ...options });

/**
 * Create an account. The address must be confirmed before content can be created.
 */
export const postApiV1AuthRegister = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthRegisterData, ThrowOnError>): RequestResult<PostApiV1AuthRegisterResponses, PostApiV1AuthRegisterErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthRegisterResponses, PostApiV1AuthRegisterErrors, ThrowOnError>({
    url: '/api/v1/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in and receive the session cookie.
 */
export const postApiV1AuthLogin = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthLoginData, ThrowOnError>): RequestResult<PostApiV1AuthLoginResponses, PostApiV1AuthLoginErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthLoginResponses, PostApiV1AuthLoginErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear the session cookie.
 */
export const postApiV1AuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1AuthLogoutData, ThrowOnError>): RequestResult<PostApiV1AuthLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostApiV1AuthLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

/**
 * The signed-in user.
 */
export const getApiV1AuthMe = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1AuthMeData, ThrowOnError>): RequestResult<GetApiV1AuthMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1AuthMeResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/me', ...options });

/**
 * Confirm an address using the token from the verification email.
 */
export const postApiV1AuthConfirmEmail = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthConfirmEmailData, ThrowOnError>): RequestResult<PostApiV1AuthConfirmEmailResponses, PostApiV1AuthConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthConfirmEmailResponses, PostApiV1AuthConfirmEmailErrors, ThrowOnError>({
    url: '/api/v1/auth/confirm-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send the verification email again.
 */
export const postApiV1AuthResendVerification = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthResendVerificationData, ThrowOnError>): RequestResult<PostApiV1AuthResendVerificationResponses, PostApiV1AuthResendVerificationErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthResendVerificationResponses, PostApiV1AuthResendVerificationErrors, ThrowOnError>({
    url: '/api/v1/auth/resend-verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a password reset link.
 */
export const postApiV1AuthForgotPassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthForgotPasswordData, ThrowOnError>): RequestResult<PostApiV1AuthForgotPasswordResponses, PostApiV1AuthForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthForgotPasswordResponses, PostApiV1AuthForgotPasswordErrors, ThrowOnError>({
    url: '/api/v1/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using the token from the reset email.
 */
export const postApiV1AuthResetPassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthResetPasswordData, ThrowOnError>): RequestResult<PostApiV1AuthResetPasswordResponses, PostApiV1AuthResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthResetPasswordResponses, PostApiV1AuthResetPasswordErrors, ThrowOnError>({
    url: '/api/v1/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change the password of the signed-in user.
 */
export const postApiV1AuthChangePassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AuthChangePasswordData, ThrowOnError>): RequestResult<PostApiV1AuthChangePasswordResponses, PostApiV1AuthChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1AuthChangePasswordResponses, PostApiV1AuthChangePasswordErrors, ThrowOnError>({
    url: '/api/v1/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permanently delete the signed-in user's account.
 */
export const deleteApiV1AuthAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1AuthAccountData, ThrowOnError>): RequestResult<DeleteApiV1AuthAccountResponses, DeleteApiV1AuthAccountErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1AuthAccountResponses, DeleteApiV1AuthAccountErrors, ThrowOnError>({
    url: '/api/v1/auth/account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search and list snippets: free text, filters, sorting, keyset paging.
 */
export const getApiV1Snippets = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SnippetsData, ThrowOnError>): RequestResult<GetApiV1SnippetsResponses, GetApiV1SnippetsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1SnippetsResponses, GetApiV1SnippetsErrors, ThrowOnError>({ url: '/api/v1/snippets', ...options });

/**
 * Create a snippet in your own library, or in a team's.
 */
export const postApiV1Snippets = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsData, ThrowOnError>): RequestResult<PostApiV1SnippetsResponses, PostApiV1SnippetsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsResponses, PostApiV1SnippetsErrors, ThrowOnError>({
    url: '/api/v1/snippets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move a snippet to the trash. Recoverable via restore.
 */
export const deleteApiV1SnippetsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdResponses, DeleteApiV1SnippetsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdResponses, DeleteApiV1SnippetsByIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}', ...options });

/**
 * Fetch one snippet with its fragments.
 */
export const getApiV1SnippetsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SnippetsByIdData, ThrowOnError>): RequestResult<GetApiV1SnippetsByIdResponses, GetApiV1SnippetsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SnippetsByIdResponses, GetApiV1SnippetsByIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}', ...options });

/**
 * Update a snippet's title and description.
 */
export const putApiV1SnippetsById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdResponses, PutApiV1SnippetsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdResponses, PutApiV1SnippetsByIdErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace a diagram's canvas. Requires Write, the same as editing a fragment.
 */
export const putApiV1SnippetsByIdDocument = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdDocumentData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdDocumentResponses, PutApiV1SnippetsByIdDocumentErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdDocumentResponses, PutApiV1SnippetsByIdDocumentErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark or unmark a snippet as a favourite.
 */
export const putApiV1SnippetsByIdFavorite = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdFavoriteData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdFavoriteResponses, PutApiV1SnippetsByIdFavoriteErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdFavoriteResponses, PutApiV1SnippetsByIdFavoriteErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive or unarchive a snippet.
 */
export const putApiV1SnippetsByIdArchive = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdArchiveData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdArchiveResponses, PutApiV1SnippetsByIdArchiveErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdArchiveResponses, PutApiV1SnippetsByIdArchiveErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bring a trashed snippet back.
 */
export const postApiV1SnippetsByIdRestore = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsByIdRestoreData, ThrowOnError>): RequestResult<PostApiV1SnippetsByIdRestoreResponses, PostApiV1SnippetsByIdRestoreErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsByIdRestoreResponses, PostApiV1SnippetsByIdRestoreErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/restore', ...options });

/**
 * Delete a trashed snippet for good. It must already be in the trash.
 */
export const deleteApiV1SnippetsByIdPermanent = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdPermanentData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdPermanentResponses, DeleteApiV1SnippetsByIdPermanentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdPermanentResponses, DeleteApiV1SnippetsByIdPermanentErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/permanent', ...options });

/**
 * Add a fragment to a snippet.
 */
export const postApiV1SnippetsByIdFragments = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsByIdFragmentsData, ThrowOnError>): RequestResult<PostApiV1SnippetsByIdFragmentsResponses, PostApiV1SnippetsByIdFragmentsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsByIdFragmentsResponses, PostApiV1SnippetsByIdFragmentsErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/fragments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a fragment.
 */
export const deleteApiV1SnippetsByIdFragmentsByFragmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdFragmentsByFragmentIdData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdFragmentsByFragmentIdResponses, DeleteApiV1SnippetsByIdFragmentsByFragmentIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdFragmentsByFragmentIdResponses, DeleteApiV1SnippetsByIdFragmentsByFragmentIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/fragments/{fragmentId}', ...options });

/**
 * Update a fragment's name, language or content.
 */
export const putApiV1SnippetsByIdFragmentsByFragmentId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdFragmentsByFragmentIdData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdFragmentsByFragmentIdResponses, PutApiV1SnippetsByIdFragmentsByFragmentIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdFragmentsByFragmentIdResponses, PutApiV1SnippetsByIdFragmentsByFragmentIdErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/fragments/{fragmentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder every fragment of a snippet.
 */
export const putApiV1SnippetsByIdFragmentsOrder = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SnippetsByIdFragmentsOrderData, ThrowOnError>): RequestResult<PutApiV1SnippetsByIdFragmentsOrderResponses, PutApiV1SnippetsByIdFragmentsOrderErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1SnippetsByIdFragmentsOrderResponses, PutApiV1SnippetsByIdFragmentsOrderErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/fragments/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach a tag by name, creating it if the caller does not have it yet.
 */
export const postApiV1SnippetsByIdTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsByIdTagsData, ThrowOnError>): RequestResult<PostApiV1SnippetsByIdTagsResponses, PostApiV1SnippetsByIdTagsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsByIdTagsResponses, PostApiV1SnippetsByIdTagsErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Detach a tag from a snippet. The tag itself is kept.
 */
export const deleteApiV1SnippetsByIdTagsByTagId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdTagsByTagIdData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdTagsByTagIdResponses, DeleteApiV1SnippetsByIdTagsByTagIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdTagsByTagIdResponses, DeleteApiV1SnippetsByIdTagsByTagIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/tags/{tagId}', ...options });

/**
 * Who this snippet is shared with.
 */
export const getApiV1SnippetsByIdShares = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SnippetsByIdSharesData, ThrowOnError>): RequestResult<GetApiV1SnippetsByIdSharesResponses, GetApiV1SnippetsByIdSharesErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SnippetsByIdSharesResponses, GetApiV1SnippetsByIdSharesErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/shares', ...options });

/**
 * Invite somebody to a personal snippet, or change what an existing share grants.
 */
export const postApiV1SnippetsByIdShares = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsByIdSharesData, ThrowOnError>): RequestResult<PostApiV1SnippetsByIdSharesResponses, PostApiV1SnippetsByIdSharesErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsByIdSharesResponses, PostApiV1SnippetsByIdSharesErrors, ThrowOnError>({
    url: '/api/v1/snippets/{id}/shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Shares of this snippet that are waiting to be accepted.
 */
export const getApiV1SnippetsByIdInvitations = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SnippetsByIdInvitationsData, ThrowOnError>): RequestResult<GetApiV1SnippetsByIdInvitationsResponses, GetApiV1SnippetsByIdInvitationsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SnippetsByIdInvitationsResponses, GetApiV1SnippetsByIdInvitationsErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/invitations', ...options });

/**
 * Send the invitation email again, and push the expiry out.
 */
export const postApiV1SnippetsByIdInvitationsByInvitationIdResend = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SnippetsByIdInvitationsByInvitationIdResendData, ThrowOnError>): RequestResult<PostApiV1SnippetsByIdInvitationsByInvitationIdResendResponses, PostApiV1SnippetsByIdInvitationsByInvitationIdResendErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1SnippetsByIdInvitationsByInvitationIdResendResponses, PostApiV1SnippetsByIdInvitationsByInvitationIdResendErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/invitations/{invitationId}/resend', ...options });

/**
 * Withdraw an invitation that has not been answered.
 */
export const deleteApiV1SnippetsByIdInvitationsByInvitationId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdInvitationsByInvitationIdData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdInvitationsByInvitationIdResponses, DeleteApiV1SnippetsByIdInvitationsByInvitationIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdInvitationsByInvitationIdResponses, DeleteApiV1SnippetsByIdInvitationsByInvitationIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/invitations/{invitationId}', ...options });

/**
 * Give up a share of somebody else's snippet.
 */
export const deleteApiV1SnippetsByIdSharesMe = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdSharesMeData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdSharesMeResponses, DeleteApiV1SnippetsByIdSharesMeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdSharesMeResponses, DeleteApiV1SnippetsByIdSharesMeErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/shares/me', ...options });

/**
 * Stop sharing a snippet with someone.
 */
export const deleteApiV1SnippetsByIdSharesByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SnippetsByIdSharesByUserIdData, ThrowOnError>): RequestResult<DeleteApiV1SnippetsByIdSharesByUserIdResponses, DeleteApiV1SnippetsByIdSharesByUserIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1SnippetsByIdSharesByUserIdResponses, DeleteApiV1SnippetsByIdSharesByUserIdErrors, ThrowOnError>({ url: '/api/v1/snippets/{id}/shares/{userId}', ...options });

/**
 * Tags the caller can see: their own, plus every team they belong to.
 */
export const getApiV1Tags = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TagsData, ThrowOnError>): RequestResult<GetApiV1TagsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1TagsResponses, unknown, ThrowOnError>({ url: '/api/v1/tags', ...options });

/**
 * Create a tag in your library, or in a team's.
 */
export const postApiV1Tags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1TagsData, ThrowOnError>): RequestResult<PostApiV1TagsResponses, PostApiV1TagsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1TagsResponses, PostApiV1TagsErrors, ThrowOnError>({
    url: '/api/v1/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a tag and detach it from every snippet.
 */
export const deleteApiV1TagsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1TagsByIdData, ThrowOnError>): RequestResult<DeleteApiV1TagsByIdResponses, DeleteApiV1TagsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1TagsByIdResponses, DeleteApiV1TagsByIdErrors, ThrowOnError>({ url: '/api/v1/tags/{id}', ...options });

/**
 * Rename or recolour a tag.
 */
export const putApiV1TagsById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1TagsByIdData, ThrowOnError>): RequestResult<PutApiV1TagsByIdResponses, PutApiV1TagsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1TagsByIdResponses, PutApiV1TagsByIdErrors, ThrowOnError>({
    url: '/api/v1/tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Teams the caller belongs to.
 */
export const getApiV1Teams = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TeamsData, ThrowOnError>): RequestResult<GetApiV1TeamsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1TeamsResponses, unknown, ThrowOnError>({ url: '/api/v1/teams', ...options });

/**
 * Create a team. The creator becomes its first owner.
 */
export const postApiV1Teams = <ThrowOnError extends boolean = false>(options: Options<PostApiV1TeamsData, ThrowOnError>): RequestResult<PostApiV1TeamsResponses, PostApiV1TeamsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1TeamsResponses, PostApiV1TeamsErrors, ThrowOnError>({
    url: '/api/v1/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a team and everything in its library. Owners only.
 */
export const deleteApiV1TeamsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1TeamsByIdData, ThrowOnError>): RequestResult<DeleteApiV1TeamsByIdResponses, DeleteApiV1TeamsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1TeamsByIdResponses, DeleteApiV1TeamsByIdErrors, ThrowOnError>({ url: '/api/v1/teams/{id}', ...options });

/**
 * One team with its members.
 */
export const getApiV1TeamsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TeamsByIdData, ThrowOnError>): RequestResult<GetApiV1TeamsByIdResponses, GetApiV1TeamsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1TeamsByIdResponses, GetApiV1TeamsByIdErrors, ThrowOnError>({ url: '/api/v1/teams/{id}', ...options });

/**
 * Rename a team. Owners only.
 */
export const putApiV1TeamsById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1TeamsByIdData, ThrowOnError>): RequestResult<PutApiV1TeamsByIdResponses, PutApiV1TeamsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1TeamsByIdResponses, PutApiV1TeamsByIdErrors, ThrowOnError>({
    url: '/api/v1/teams/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invitations this team is waiting on, and what recently became of them.
 */
export const getApiV1TeamsByIdInvitations = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TeamsByIdInvitationsData, ThrowOnError>): RequestResult<GetApiV1TeamsByIdInvitationsResponses, GetApiV1TeamsByIdInvitationsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1TeamsByIdInvitationsResponses, GetApiV1TeamsByIdInvitationsErrors, ThrowOnError>({ url: '/api/v1/teams/{id}/invitations', ...options });

/**
 * Invite an address to the team. Admins and owners only.
 */
export const postApiV1TeamsByIdInvitations = <ThrowOnError extends boolean = false>(options: Options<PostApiV1TeamsByIdInvitationsData, ThrowOnError>): RequestResult<PostApiV1TeamsByIdInvitationsResponses, PostApiV1TeamsByIdInvitationsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1TeamsByIdInvitationsResponses, PostApiV1TeamsByIdInvitationsErrors, ThrowOnError>({
    url: '/api/v1/teams/{id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send the invitation email again, and push the expiry out.
 */
export const postApiV1TeamsByIdInvitationsByInvitationIdResend = <ThrowOnError extends boolean = false>(options: Options<PostApiV1TeamsByIdInvitationsByInvitationIdResendData, ThrowOnError>): RequestResult<PostApiV1TeamsByIdInvitationsByInvitationIdResendResponses, PostApiV1TeamsByIdInvitationsByInvitationIdResendErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1TeamsByIdInvitationsByInvitationIdResendResponses, PostApiV1TeamsByIdInvitationsByInvitationIdResendErrors, ThrowOnError>({ url: '/api/v1/teams/{id}/invitations/{invitationId}/resend', ...options });

/**
 * Withdraw an invitation that has not been answered.
 */
export const deleteApiV1TeamsByIdInvitationsByInvitationId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1TeamsByIdInvitationsByInvitationIdData, ThrowOnError>): RequestResult<DeleteApiV1TeamsByIdInvitationsByInvitationIdResponses, DeleteApiV1TeamsByIdInvitationsByInvitationIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1TeamsByIdInvitationsByInvitationIdResponses, DeleteApiV1TeamsByIdInvitationsByInvitationIdErrors, ThrowOnError>({ url: '/api/v1/teams/{id}/invitations/{invitationId}', ...options });

/**
 * Remove a member, or leave the team yourself.
 */
export const deleteApiV1TeamsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1TeamsByIdMembersByUserIdData, ThrowOnError>): RequestResult<DeleteApiV1TeamsByIdMembersByUserIdResponses, DeleteApiV1TeamsByIdMembersByUserIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1TeamsByIdMembersByUserIdResponses, DeleteApiV1TeamsByIdMembersByUserIdErrors, ThrowOnError>({ url: '/api/v1/teams/{id}/members/{userId}', ...options });

/**
 * Change a member's role. Admins and owners only.
 */
export const putApiV1TeamsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1TeamsByIdMembersByUserIdData, ThrowOnError>): RequestResult<PutApiV1TeamsByIdMembersByUserIdResponses, PutApiV1TeamsByIdMembersByUserIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1TeamsByIdMembersByUserIdResponses, PutApiV1TeamsByIdMembersByUserIdErrors, ThrowOnError>({
    url: '/api/v1/teams/{id}/members/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invitations addressed to the signed-in user's confirmed address.
 */
export const getApiV1Invitations = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1InvitationsData, ThrowOnError>): RequestResult<GetApiV1InvitationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1InvitationsResponses, unknown, ThrowOnError>({ url: '/api/v1/invitations', ...options });

/**
 * Accept an invitation: join the team, or take up the share.
 */
export const postApiV1InvitationsByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostApiV1InvitationsByIdAcceptData, ThrowOnError>): RequestResult<PostApiV1InvitationsByIdAcceptResponses, PostApiV1InvitationsByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1InvitationsByIdAcceptResponses, PostApiV1InvitationsByIdAcceptErrors, ThrowOnError>({ url: '/api/v1/invitations/{id}/accept', ...options });

/**
 * Turn an invitation down.
 */
export const postApiV1InvitationsByIdDecline = <ThrowOnError extends boolean = false>(options: Options<PostApiV1InvitationsByIdDeclineData, ThrowOnError>): RequestResult<PostApiV1InvitationsByIdDeclineResponses, PostApiV1InvitationsByIdDeclineErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1InvitationsByIdDeclineResponses, PostApiV1InvitationsByIdDeclineErrors, ThrowOnError>({ url: '/api/v1/invitations/{id}/decline', ...options });

/**
 * What a seat costs and how many are free.
 */
export const getApiV1BillingPlan = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1BillingPlanData, ThrowOnError>): RequestResult<GetApiV1BillingPlanResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1BillingPlanResponses, unknown, ThrowOnError>({ url: '/api/v1/billing/plan', ...options });

/**
 * A team's subscription state, seats used and seats billed.
 */
export const getApiV1BillingTeamsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1BillingTeamsByIdData, ThrowOnError>): RequestResult<GetApiV1BillingTeamsByIdResponses, GetApiV1BillingTeamsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1BillingTeamsByIdResponses, GetApiV1BillingTeamsByIdErrors, ThrowOnError>({ url: '/api/v1/billing/teams/{id}', ...options });

/**
 * Start a subscription for a team. Owners only.
 */
export const postApiV1BillingTeamsByIdCheckout = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BillingTeamsByIdCheckoutData, ThrowOnError>): RequestResult<PostApiV1BillingTeamsByIdCheckoutResponses, PostApiV1BillingTeamsByIdCheckoutErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1BillingTeamsByIdCheckoutResponses, PostApiV1BillingTeamsByIdCheckoutErrors, ThrowOnError>({ url: '/api/v1/billing/teams/{id}/checkout', ...options });

/**
 * A link to the provider's billing portal. Owners only.
 */
export const postApiV1BillingTeamsByIdPortal = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BillingTeamsByIdPortalData, ThrowOnError>): RequestResult<PostApiV1BillingTeamsByIdPortalResponses, PostApiV1BillingTeamsByIdPortalErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1BillingTeamsByIdPortalResponses, PostApiV1BillingTeamsByIdPortalErrors, ThrowOnError>({ url: '/api/v1/billing/teams/{id}/portal', ...options });

/**
 * Cancel at the end of the paid period. Owners only.
 */
export const deleteApiV1BillingTeamsByIdSubscription = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1BillingTeamsByIdSubscriptionData, ThrowOnError>): RequestResult<DeleteApiV1BillingTeamsByIdSubscriptionResponses, DeleteApiV1BillingTeamsByIdSubscriptionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1BillingTeamsByIdSubscriptionResponses, DeleteApiV1BillingTeamsByIdSubscriptionErrors, ThrowOnError>({ url: '/api/v1/billing/teams/{id}/subscription', ...options });
